<template>
    <div class="blocks card mt-3">
        <div class="card-header">
            <slot name="title">{{ title }}</slot>
            <span class="float-right m-0">
                <label>Show on Store:</label>
                <b-select class="w-50" size="sm" v-model="block.store">
                    <b-select-option :value="null">School & Homeschool</b-select-option>
                    <b-select-option value="school">School Only</b-select-option>
                    <b-select-option value="homeschool">Homeschool Only</b-select-option>
                </b-select>
            </span>
            <span v-if="optional"
                @click="this.$emit('delete')"
                class="float-right delete-block-btn"
            >
                <font-awesome-icon :icon="['fas', 'times-circle']"></font-awesome-icon>
            </span>
        </div>
        <slot name="cardbody">
            <div>
                <slot>
                </slot>
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    name: "EditorBlock",
    props: {
        title: String,
        optional: {
            type: Boolean,
            default: false,
        },
        showCardBody: {
            type: Boolean,
            default: true,
        },
        block: Object,
    },
}
</script>

<style scoped>
.delete-block-btn {
    position: absolute;
    top: -10px;
    right: -6px;
    color: red;
}
.delete-block-btn:hover {
    color:darkred;
    cursor: pointer;
}

</style>